import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import get from 'lodash/get';
import { BaseModal } from 'components/UI';
import { VehiclesGroupsLocations } from 'components/VehiclesGroups/VehiclesGroupsWizard';

const ChangeLocationsModal = ({ open, type, steps, title, loading, currentGroup, handleClick }) => {
  let parentGroup = get(currentGroup, 'parent.id', false)
    ? currentGroup.parent.id
    : currentGroup.parent;
  return (
    <BaseModal
      size="lg"
      open={open}
      maxWidth={1160}
      loading={false}
      handleClick={handleClick}
      title={title || i18n.t('locations.edit')}
    >
      <VehiclesGroupsLocations
        type={type}
        loading={loading}
        step={steps.locations}
        currentGroup={currentGroup}
        parentGroup={parentGroup}
        showAvailableZoneText={false}
      />
    </BaseModal>
  );
};

ChangeLocationsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};

ChangeLocationsModal.defaultProps = {
  open: false,
  handleClick: () => {},
};

export default ChangeLocationsModal;
